var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper"},[_c('TheHeader'),_c('div',{staticClass:"merchandise-header has-text-centered"}),_c('div',{staticClass:"af-container"},[_vm._t("default")],2),_c('div',{staticClass:"af-footer"},[_c('TheFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }